import { CDN_URL } from '../../../modules/vars'

export const CDN_BUSINESS_URL_PREFIX = `${CDN_URL}/web/ab-test/landing-b2b`

export const IMG_BUSINESS_CERTIFIED_ICON = `${CDN_BUSINESS_URL_PREFIX}/certified.svg`
export const IMG_BUSINESS_HELPCENTER_ICON = `${CDN_BUSINESS_URL_PREFIX}/helpcenter.svg`
export const IMG_BUSINESS_PERSON_ICON = `${CDN_BUSINESS_URL_PREFIX}/person.svg`
export const IMG_BUSINESS_CHECK_ICON = `${CDN_BUSINESS_URL_PREFIX}/check.svg`

export const IMG_BUSINESS_SYSTEM_IMG_DESKTOP = `${CDN_BUSINESS_URL_PREFIX}/desktop/system.webp`
export const IMG_BUSINESS_SYSTEM_IMG_MOBILE = `${CDN_BUSINESS_URL_PREFIX}/mobile/system.webp`

export const IMG_BUSINESS_COMPANY_1 = `${CDN_BUSINESS_URL_PREFIX}/mobile/company-1.png`
export const IMG_BUSINESS_COMPANY_2 = `${CDN_BUSINESS_URL_PREFIX}/mobile/company-2.png`
export const IMG_BUSINESS_COMPANY_3 = `${CDN_BUSINESS_URL_PREFIX}/mobile/company-3.png`
export const IMG_BUSINESS_COMPANY_4 = `${CDN_BUSINESS_URL_PREFIX}/mobile/company-4.png`
export const IMG_BUSINESS_COMPANY_5 = `${CDN_BUSINESS_URL_PREFIX}/mobile/company-5.png`
